import { createIcon } from "@chakra-ui/react";

export const NavCollapseIcon = createIcon({
  displayName: "NavCollapseIcon",
  viewBox: "0 0 17 17",
  path: (
    <path
      d="M7.55319 12.1909L4.15541 8.92327L7.42303 5.52549M12.219 12.0998L8.82119 8.83216L12.0888 5.43438"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  ),
  defaultProps: {
    width: "16px",
    height: "16px",
  },
});
